
import axios from 'axios'
import { url } from './url'

function getCustomers() {
    var urlString = `${url}/customer`;
    return axios
        .get(urlString)
        .then(res => res.data);
}

function updateCustomer(form) {
    return axios.put(`${url}/customer/${form._id}/`,form)
        .then(resp => {
            return resp.data
        })
}
function getOneCustomers(id) {
    return axios.get(`${url}/customer/${id}`)
        .then(resp => {
            return resp.data
        })
}

function createCustomer(customer){
    return axios.post(`${url}/customer`,customer)
    .then(resp => {
        return resp.data
    })
}

export default {
    getCustomers,
    getOneCustomers,
    createCustomer,
    updateCustomer,
    
};